<script>
  import { onMount } from "svelte";
  import { scrollTo } from "../../../library/function/browser";
  import Link from "./Link.svelte";

  export let fab_item = {};
  export let classNames = "";

  let scrollOffsetY = 0;
  let scrollOffset = fab_item ? fab_item.module.options.offset.value : 0;
  let activeAnimation = "";
  let shouldHide = true; // Start hidden by default
  let animationEndHandler;

  const { in: animIn, out: animOut, duration } = fab_item.module.options.animation.children;

  // Transform FAB Item
  fab_item.title = "";

  // Handle scroll visibility with animation timing
  $: {
    if (scrollOffsetY > scrollOffset) {
      // Show element with fade-in animation
      shouldHide = false;
      activeAnimation = `animate__${animIn.value}`;
    } else if (!shouldHide) {
      // Only start fade-out if currently visible
      activeAnimation = `animate__${animOut.value}`;
    }
  }

  // Handle click
  function handle_click(e) {
    scrollTo(document.documentElement, 0, duration.value);
  }

  // Clean up event listener
  onMount(() => {
    const element = document.querySelector(".fab-scroll-to-top");

    animationEndHandler = (event) => {
      if (event.animationName.includes(animOut.value)) {
        // Only hide after fade-out completes
        shouldHide = true;
      }
    };

    element.addEventListener("animationend", animationEndHandler);

    return () => {
      element.removeEventListener("animationend", animationEndHandler);
    };
  });
</script>

<span
  hidden={shouldHide}
  class="fab fab-scroll-to-top fab-links animate__animated {activeAnimation}"
  style={`
    --animate-duration: ${duration.value / 1000}s;
  `}
>
  <Link {fab_item} {classNames} on:click={handle_click} />
</span>

<svelte:window bind:scrollY={scrollOffsetY} />
